import { EmptyInstance } from "core-library/mixins/empty-instance";
import { EventEmitterMixin } from "widgets-module/mixins/event-emitter.mixin";

export class FavoutitesItemComponent extends EventEmitterMixin(EmptyInstance) {
    public static readonly SELECTOR = ".js-article";
    public static readonly REMOVE_EVENT = "favourite-item/remove";

    private readonly _classMap = {
        closeButtonSelector: ".js-remove-favourite"
    };

    private _currentContext: JQuery = null;
    private _closeButton: JQuery = null;

    private _id: string = null;
    public get id(): string {
        return this._id;
    }

    public destroy = (): void => this.complete(FavoutitesItemComponent.REMOVE_EVENT);

    private bindEvents(): void {
        this._closeButton.on("click", () => {
            this._currentContext.hide();
            this.emit(FavoutitesItemComponent.REMOVE_EVENT, this);
        });
    }

    private parseContext(): void {
        this._closeButton = $(this._classMap.closeButtonSelector, this._currentContext);
        this._id = this._closeButton?.data("id") as string;
    }

    public init(context: JQuery): void {
        this._currentContext = context || this._currentContext;

        this.parseContext();
        this.bindEvents();
    }
}
